<template>
    <div v-frag>
      <CardIeaAppMain>
        <v-col v-if="user && user.tipoUsuario == 'profesor'" cols="12" class="px-4 mb-4">
          <div class="text-h5 primary--text d-flex align-center flex-wrap">
            Ir a nuevo Portal Docente
            <v-switch
              v-model="switchLegacyVersion"
              @change="handleSwitchNewVersion"
              hide-details
              class="ml-4 mt-0 pt-0"
            ></v-switch>
          </div>
          <v-divider class="mt-2"></v-divider>
        </v-col>
        <div v-if="user && user.tipoUsuario == 'alumno'" style="width: 100%">
          <!-- Skeleton shimmer while checking documents and notifications on initial load -->
          <v-col cols="12" class="py-1" v-if="waiting && (!documentosAlumno || documentosAlumno.length === 0)">
            <v-card elevation="0" class="rounded-huge glass-card overflow-hidden border-light mb-2 pa-4">
              <div class="d-flex align-center">
                <div class="skeleton-avatar-sm rounded-circle mr-4"></div>
                <div class="flex-grow-1">
                  <div class="skeleton-line-title rounded-pill mb-2"></div>
                  <div class="skeleton-line-sub rounded-pill"></div>
                </div>
              </div>
            </v-card>
          </v-col>

          <v-slide-y-transition>
            <div v-if="docsPend == 0 && waiting == false" style="width: 100%">
            <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
              <v-card elevation="0" class="rounded-huge glass-card hover-lift" color="success" dark>
                <v-card-title class="justify-center font-weight-bold">
                  <v-icon left>mdi-check-circle-outline</v-icon>
                  Documentación Completa
                </v-card-title>
              </v-card>
            </v-col>
          </div>
          <div v-else>
            <v-col
              v-if="docsPend > 0"
              cols="12"
              sm="12"
              xs="12"
              md="12"
              lg="12"
              xl="12"
              class="py-1"
            >
              <v-card elevation="0" class="rounded-huge glass-card overflow-hidden shadow-premium border-light mb-2 pulse-warning hover-lift">
                <div class="pa-4 d-flex align-center border-bottom" style="background-color: rgba(245, 158, 11, 0.08) !important;">
                  <v-avatar color="warning" size="40" class="mr-4 elevation-2">
                    <v-icon color="white">mdi-file-alert-outline</v-icon>
                  </v-avatar>
                  <div>
                    <div class="text-subtitle-1 font-weight-bold warning--text text--darken-3 mb-0" style="line-height: 1.2;">
                      Documentos Requeridos
                    </div>
                    <div class="text-caption grey--text text--darken-1">
                      Acción necesaria para completar tu legajo
                    </div>
                  </div>
                </div>
                
                <v-card-text class="pa-6">
                  <ul class="text-body-2 grey--text text--darken-3 pl-6" style="line-height: 1.4;">
                    <template v-for="(documento, index) in documentosAlumno">
                      <li
                        v-if="
                          documento.validar == 0 &&
                            documento.nameDocumento !=
                              'Formulario de Contacto a Inscripción'
                        "
                        :key="'doc-req-' + index"
                        class="mb-1"
                      >
                        {{ documento.nameDocumento }}
                      </li>
                      <li
                        v-else-if="
                          documento.validar == 0 &&
                            documento.nameDocumento ==
                              'Formulario de Contacto a Inscripción'
                        "
                        :key="'doc-req-' + index"
                        class="mb-1"
                      >
                        <router-link to="/contactoDatos" class="warning--text font-weight-bold text-decoration-none hover-underline">
                          {{ documento.nameDocumento }}
                          <v-icon x-small color="warning" class="ml-1">mdi-arrow-right</v-icon>
                        </router-link>
                      </li>
                    </template>
                  </ul>
                </v-card-text>
              </v-card>
            </v-col>
          </div>
  
          </v-slide-y-transition>

          <v-slide-y-transition>
            <v-col
              v-if="waiting == false && tituloNovedades"
              cols="12"
              sm="12"
              xs="12"
              md="12"
              lg="12"
              class="py-1"
            >
              <v-card elevation="0" class="rounded-huge glass-card overflow-hidden shadow-premium border-light mb-2 hover-lift">
                <div class="pa-4 d-flex align-center border-bottom" style="background-color: rgba(37, 99, 235, 0.08) !important;">
                  <v-avatar color="primary" size="40" class="mr-4 elevation-2">
                    <v-icon color="white">mdi-bullhorn-outline</v-icon>
                  </v-avatar>
                  <div>
                    <div class="text-subtitle-1 font-weight-bold primary--text text--darken-3 mb-0" style="line-height: 1.2;">
                      {{ tituloNovedades }}
                    </div>
                    <div class="text-caption grey--text text--darken-1">
                      Novedades y comunicados de la institución
                    </div>
                  </div>
                </div>
                <v-card-text class="pa-6">
                  <div class="text--primary text-body-2 grey--text text--darken-3" style="line-height: 1.6;">
                    {{ descripcionNovedades }}
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-slide-y-transition>
  
          <v-col
            v-if="llenarFormulario != false"
            cols="12"
            sm="12"
            xs="12"
            md="12"
            lg="12"
            xl="12"
            class="py-1"
          >
            <v-alert title="Formulario de Inscripción BCE" prominent type="info">
              Tienes pendiente el llenado del formulario de inscripción de
              contacto.
              {{
                existeContactoBce
                  ? `Completar
              antes de: ` +
                    (contactoBce.fecha_atencion +
                      " a las " +
                      contactoBce.hora_atencion)
                  : ""
              }}
              <router-link to="contactoDatos" class="text-button white--text"
                >Llenar Formulario</router-link
              >
            </v-alert>
          </v-col>
          <v-col
            v-if="existeContactoBce != false"
            cols="12"
            sm="12"
            xs="12"
            md="12"
            lg="12"
            xl="12"
            class="py-1"
          >
            <v-alert
              title=" Reunión para Inscripción a Materias"
              prominent
              type="info"
            >
              Tiene una reunión para inscripción a materias el día
              {{ contactoBce.fecha_atencion }} a las
              {{ contactoBce.hora_atencion }}
              {{
                contactoBce.usuario
                  ? "con " + contactoBce.usuario.usu_nombre
                  : "."
              }}
              <div>
                En caso de NO estar disponible el día y horario de la entrevista
                asignada, podrá conectarse directamente usted mismo/a de lunes a
                viernes de 10:30 am a 20:00 pm, en el siguiente enlace de
                videollamada:
                <a
                  href="https://meet.google.com/orn-enpg-ovc"
                  target="_blank"
                  style="color: #1976D2; text-decoration: underline;"
                >
                  Click Aquí </a
                >.
              </div>
            </v-alert>
          </v-col>
          <v-col
            v-if="user && user.pendiente_documentos_inscripcion == 0"
            cols="12"
            sm="12"
            xs="12"
            md="12"
            lg="12"
            xl="12"
            class="py-1"
          >
            <v-alert title="Documentos de inscripción" prominent type="info">
              Tienes pendiente la validación de tus documentos de inscripción !
            </v-alert>
          </v-col>
          <div class="text-center">
            <v-dialog v-model="dialog_pago_atrasado" width="700">
              <v-card>
                <v-card-text>
                  <br />
                  <h4>
                    Estimado/a alumno/a; al dia de la fecha tiene cuota/s impagas,
                    por favor procure realizar los pagos lo antes posible, a fin
                    de evitar el pasaje automático de su cuenta a estado de mora.
                    Puede regularizar su deuda desde la sección "Pagar curso"; o
                    enviar una consulta para que le indiquen los pasos a seguir.
                  </h4>
                </v-card-text>
                <v-card-actions>
                  <v-btn
                    color="warning"
                    block
                    @click="dialog_pago_atrasado = false"
                    >Cerrar</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
  
          <div v-if="user && user.alumno_mora" style="width: 100%">
            <v-col cols="12" xs="12" sm="12" md="12" xl="12" lg="12">
              <v-alert prominent type="error">
                Su usuario se encuentra en estado de Mora. Si desea retomar sus
                estudios, puede regularizar su deuda desde la sección Pagar curso;
                o enviar una consulta para que le indiquen los pasos a seguir para
                obtener el alta
              </v-alert>
            </v-col>
          </div>
          <div v-else-if="user && (user.borrado == '1' || user.excedente)" style="width: 100%">
            <v-col cols="12" xs="12" sm="12" md="12" xl="12" lg="12">
              <v-alert prominent type="error">
                Su usuario se encuentra dado de baja. Si desea retomar sus
                estudios, en el caso que usted posea deuda, puede regularizarla
                sección Pagar curso; o enviar una consulta para que le indiquen
                los pasos a seguir para obtener el alta
              </v-alert>
            </v-col>
          </div>
  
          <div
            v-if="
              alumnoCursoIntroductorio != null &&
                Object.keys(alumnoCursoIntroductorio).length != 0
            "
          >
            <div style="width: 100%">
              <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
                <v-card elevation="0" class="rounded-xl" color="secondaryApp">
                  <v-card-title
                    style="
                      display: flex;
                      justify-content: center;
                      background-color: rgb(58, 66, 153);
                      color: white;
                    "
                  >
                    Curso introductorio completado !
                  </v-card-title>
                </v-card>
              </v-col>
            </div>
          </div>
  
          <div
            v-else-if="user && user.fechaIncripcion && diferenciaDias > 0"
            @click="videoCourse()"
            style="cursor: pointer"
          >
            <div style="width: 100%">
              <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
                <v-card elevation="0" class="rounded-xl" color="secondaryApp">
                  <v-card-title
                    style="
                      display: flex;
                      justify-content: center;
                      background-color: rgb(58, 66, 153);
                      color: white;
                    "
                  >
                    Te quedan {{ diferenciaDias }} días para completar el curso
                    introductorio y obtener tu recompensa
                  </v-card-title>
                </v-card>
              </v-col>
            </div>
          </div>
        </div>
  
  
        <!-- <v-row justify="center" align-content="center" align="start"> -->
        <!-- Skeleton cards while menu is loading and no items in cache -->
        <template v-if="loadingMenu && menuValidar.length === 0">
          <v-col
            cols="6"
            xs="6"
            sm="4"
            md="3"
            xl="2"
            lg="2"
            v-for="n in 12"
            :key="'skeleton-cat-' + n"
            align-self="start"
          >
            <v-card
              class="rounded-huge glass-card menu-card-skeleton d-flex flex-column align-center justify-center pa-4"
              height="180"
              width="100%"
              elevation="0"
            >
              <div class="skeleton-icon-box rounded-xl mb-4"></div>
              <div class="skeleton-text-pill rounded-pill"></div>
            </v-card>
          </v-col>
        </template>

        <v-col
          cols="6"
          xs="6"
          sm="4"
          md="3"
          xl="2"
          lg="2"
          v-for="(item, index) in menuValidar"
          :key="index"
          align-self="start"
          class="menu-stagger-item"
          :style="{ animationDelay: (index * 0.02) + 's' }"
        >
          <CardIeaCategory
            :text="item.text"
            :color="
              user && (user.borrado == '1' || user.alumno_mora || user.excedente) && item.validate
                ? '#dfdfdf'
                : item.color
            "
            :icon="require('../assets/categories/' + item.icon)"
            :newOption="item.new"
            v-if="
              (item.show && item.text != 'Administrá Tareas') ||
                (item.text == 'Administrá Tareas' && showButtonClock)
            "
            @press="menuAction(item.route, item.validate)"
          />
        </v-col>
        <!-- </v-row> -->
      </CardIeaAppMain>
      <br />
      <div
        v-if="
          user && ( user.borrado !== '1' &&
            user.alumno_mora !== true && 
            !user.excedente &&
            user.validacion_inscripcion != 0) && ocultarPanels==false
        "
        style="margin-bottom: 85px"
      >
        <div v-frag v-for="(item, i) in panels" :key="i">
          <v-card
            class="rounded-huge glass-card mb-6 overflow-hidden"
            v-if="item.id != 0"
          >
            <!-- <v-container :class=\"$vuetify.breakpoint.name == 'xs' ? '' :'pr-8 pl-8'\" fluid> -->
            <v-row
              align="center"
              justify="center"
              align-content="center"
              v-if="user && user.tipoUsuario == 'alumno'"
            >
              <v-col cols="12" xs="12" sm="12" md="12" xl="12" lg="12">
                <v-row @click="openPanel(item)" no-gutters class="py-4 px-6 cursor-pointer hover-lift">
                  <v-col
                    cols="9"
                    align-self="center"
                  >
                    <div
                      class="text-h6 font-weight-bold primary--text"
                    >
                      {{ item.text }}
                    </div>
                  </v-col>
                  <v-col
                    cols="3"
                    align-self="center"
                    class="d-flex justify-end"
                  >
                    <v-btn
                      icon
                      color="primary"
                      class="glass-btn"
                    >
                      <v-icon x-large v-if="!item.active">
                        mdi-chevron-down
                      </v-icon>
                      <v-icon x-large v-if="item.active">
                        mdi-chevron-up
                      </v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
                <v-expand-transition>
                  <v-row v-show="item.active" align="center">
                    <v-col cols="12" xs="12" sm="12" md="12" xl="12" lg="12">
                      <!-- class room -->
                      <div v-frag v-if="item.id == 2">
                        <div
                          v-frag
                          v-for="(planDeEstudio, planDeEstudioKey) in item.data"
                          :key="planDeEstudioKey"
                        >
                          <div
                            class="text-xs-h4 text-sm-h4 text-md-h4 text-lg-h4 text-xl-h4 primary--text"
                          >
                            {{ planDeEstudio.CursoNombre }}
                          </div>
                          <v-simple-table>
                            <template v-slot:default>
                              <thead>
                                <tr>
                                  <th class="text-left">Plan de estudio</th>
                                  <th class="text-left">Código ClassRoom</th>
                                  <th class="text-left">ClassRoom (BETA)</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-for="(planDeEstudioData,
                                  planDeEstudioDataKey) in planDeEstudio.planDeEstudio"
                                  :key="planDeEstudioDataKey"
                                >
                                  <td>
                                    {{
                                      $vuetify.breakpoint.name == "xs"
                                        ? planDeEstudioData.catedraMin
                                        : planDeEstudioData.catedra
                                    }}
                                  </td>
                                  <td>{{ planDeEstudioData.codClassRoom }}</td>
                                  <td>
                                    <div
                                      v-frag
                                      v-if="planDeEstudioData.link != ''"
                                    >
                                      <v-btn
                                        @click="linkVideo(planDeEstudioData)"
                                        small
                                        class="info--text text-decoration-underline font-weight-regular"
                                        depressed
                                        text
                                        color="info"
                                        >Ver Aquí</v-btn
                                      >
                                    </div>
                                    <div v-frag v-else>
                                      <b class="text-center">Sin contenido aún</b>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </template>
                          </v-simple-table>
                        </div>
                      </div>
                      <!-- class room -->
                      <!-- mesa de exames -->
                      <div v-frag v-if="item.id == 1">
                        <br />
                        <div
                          v-frag
                          v-for="(examenMesa, examenMesaKey) in item.data.data"
                          :key="examenMesaKey"
                        >
                          <v-row>
                            <div
                              class="text-xs-h4 text-sm-h4 text-md-h4 text-lg-h4 text-xl-h4 primary--text"
                            >
                              <v-card elevation="0">
                                <v-card-text
                                  v-if="examenMesa.cantidadInscipcion > 0"
                                >
                                  Cantidad de materia disponibles :
                                  {{ examenMesa.cantidadInscipcion }}
                                </v-card-text>
                                <v-card-text v-else>
                                  Cantidad de materia disponibles : 0
                                </v-card-text>
                              </v-card>
                              {{ examenMesa.curso.Feriado }}
                            </div>
  
                            <ModalSubsripcionExterna
                              :inscripcionesDisponibles="
                                examenMesa.cantidadInscipcionAntesDescuento
                              "
                              :montoXmateria="parseInt(examenMesa.montoXmateria)"
                              :idMesa="parseInt(examenMesa.id)"
                              v-if="
                                examenMesa.muestraBotonTolerancia &&
                                  examenMesa.cantidadInscipcionAntesDescuento
                                    .length > 0
                              "
                            />
  
                            <v-btn
                              color="primary"
                              v-if="examenMesa.tieneDeudaGeneral"
                              @click="pagarMontoDeuda(examenMesa.id)"
                            >
                              Pagar Deuda : {{ examenMesa.montoDeudaGeneral }}
                            </v-btn>
                          </v-row>
                          <v-simple-table
                            style="
                              margin-top: 10px;
                              margin-bottom: 30px;
                              text-align: center;
                              vertical-align: middle !important ;
                            "
                          >
                            <template v-slot:default>
                              <thead>
                                <tr>
                                  <th class="text-center">Examen</th>
                                  <th class="text-center">
                                    Validación académica
                                  </th>
                                  <th class="text-center">Validación de pago</th>
                                  <th class="text-center">Estado</th>
                                  <th class="text-center">Acciónes</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-for="(planDeEstudioData,
                                  planDeEstudioDataKey) in examenMesa.curso
                                    .plan_de_estudio_v2"
                                  :key="planDeEstudioDataKey"
                                >
                                  <td
                                    v-if="
                                      planDeEstudioData.tipo == 1 ||
                                        planDeEstudioData.tipo == 3 ||
                                        planDeEstudioData.tipo == 2 ||
                                        planDeEstudioData.tipo == 4
                                    "
                                    class="td-mesa"
                                    style="
                                      border-left: 1px solid #ddd;
                                      border-bottom: 1px solid #ddd;
                                      width: 30%;
                                      text-align: left !important;
                                    "
                                  >
                                    {{ planDeEstudioData.Materia }}
                                  </td>
  
                                  <td
                                    v-if="
                                      planDeEstudioData.tipo == 1 ||
                                        planDeEstudioData.tipo == 3 ||
                                        planDeEstudioData.tipo == 2 ||
                                        planDeEstudioData.tipo == 4
                                    "
                                    class="td-mesa"
                                    style="
                                      border-bottom: 1px solid #ddd;
                                      width: 10%;
                                    "
                                  >
                                    <span
                                      v-if="
                                        planDeEstudioData.validacion_academica ==
                                          'aceptada' &&
                                          (planDeEstudioData.validacion_pago ==
                                            'aceptada' ||
                                            planDeEstudioData.validacion_pago ===
                                              null) &&
                                          planDeEstudioData.status != 0
                                      "
                                      style="color: green"
                                      >&#10004;
                                    </span>
                                    <span
                                      v-else-if="
                                        planDeEstudioData.validacion_academica ==
                                          'aceptada' &&
                                          planDeEstudioData.nuevo_monto_deuda >
                                            0 &&
                                          planDeEstudioData.status != 0
                                      "
                                      style="color: green"
                                      >&#10004;
                                    </span>
                                    <span
                                      v-else-if="
                                        planDeEstudioData.validacion_academica ==
                                          'rechazada' &&
                                          planDeEstudioData.status != 0
                                      "
                                      style="color: red"
                                      >&#10006;
                                    </span>
                                    <span
                                      v-else-if="planDeEstudioData.status == 0"
                                    >
                                    </span>
                                  </td>
  
                                  <td
                                    v-if="
                                      planDeEstudioData.tipo == 1 ||
                                        planDeEstudioData.tipo == 3 ||
                                        planDeEstudioData.tipo == 2 ||
                                        planDeEstudioData.tipo == 4
                                    "
                                    class="td-mesa"
                                    style="
                                      border-bottom: 1px solid #ddd;
                                      width: 10%;
                                    "
                                  >
                                    <div
                                      v-if="
                                        planDeEstudioData.nuevo_monto_deuda > 0 &&
                                          planDeEstudioData.validacion_pago ==
                                            'rechazada' &&
                                          planDeEstudioData.status != 0
                                      "
                                    >
                                      <span style="color: red">&#10006;</span>
                                    </div>
                                    <div
                                      v-else-if="
                                        btnDeshabilitadoDeuda == true &&
                                          planDeEstudioData.validacion_pago ==
                                            'rechazada' &&
                                          planDeEstudioData.status != 0
                                      "
                                    >
                                      <span style="color: red">&#10006;</span>
                                    </div>
                                    <div
                                      v-else-if="
                                        planDeEstudioData.validacion_pago ==
                                          'aceptada' &&
                                          planDeEstudioData.status != 0
                                      "
                                    >
                                      <span style="color: green">&#10004;</span>
                                    </div>
                                    <div
                                      v-else-if="
                                        planDeEstudioData.validacion_pago ==
                                          'rechazada' &&
                                          planDeEstudioData.validacion_academica ==
                                            'rechazada' &&
                                          planDeEstudioData.nuevo_monto_deuda <=
                                            0 &&
                                          planDeEstudioData.status != 0
                                      "
                                    >
                                      <span style="color: green">&#10004;</span>
                                    </div>
                                    <div
                                      v-else-if="planDeEstudioData.status == 0"
                                      id="mostarNoData_validacion_pago"
                                    >
                                      <span></span>
                                    </div>
                                  </td>
  
                                  <td
                                    v-if="
                                      planDeEstudioData.tipo == 1 ||
                                        planDeEstudioData.tipo == 3 ||
                                        planDeEstudioData.tipo == 2 ||
                                        planDeEstudioData.tipo == 4
                                    "
                                    class="td-mesa"
                                    id="td_motivo"
                                    style="
                                      border-bottom: 1px solid #ddd;
                                      width: 20%;
                                    "
                                  >
                                    <div
                                      v-if="
                                        planDeEstudioData.motivo_rechazo &&
                                          planDeEstudioData.validacion_pago ==
                                            'rechazada' &&
                                          planDeEstudioData.rechazo_pago == 1 &&
                                          planDeEstudioData.status != 0
                                      "
                                    >
                                      {{ planDeEstudioData.motivo_rechazo }}
                                      <br />
                                    </div>
                                    <div
                                      v-else-if="
                                        planDeEstudioData.motivo_rechazo &&
                                          planDeEstudioData.validacion_academica ==
                                            'rechazada' &&
                                          planDeEstudioData.rechazo_pago ===
                                            null &&
                                          planDeEstudioData.status != 0
                                      "
                                    >
                                      {{ planDeEstudioData.motivo_rechazo }}
                                    </div>
                                    <div
                                      v-else-if="
                                        planDeEstudioData.motivo_rechazo &&
                                          planDeEstudioData.rechazo_pago === null
                                      "
                                    >
                                      {{ planDeEstudioData.motivo_rechazo }}
                                    </div>
                                    <div
                                      v-else-if="
                                        planDeEstudioData.validacion_pago ==
                                          'rechazada' &&
                                          planDeEstudioData.validacion_academica ==
                                            'rechazada' &&
                                          planDeEstudioData.nuevo_monto_deuda <=
                                            0 &&
                                          planDeEstudioData.status != 0
                                      "
                                    >
                                      {{ planDeEstudioData.motivo_rechazo }}
                                    </div>
                                    <div
                                      v-else-if="planDeEstudioData.status == 0"
                                    ></div>
                                  </td>
  
                                  <td
                                    v-if="
                                      planDeEstudioData.tipo == 1 ||
                                        planDeEstudioData.tipo == 3 ||
                                        planDeEstudioData.tipo == 2 ||
                                        planDeEstudioData.tipo == 4
                                    "
                                    style="
                                      vertical-align: middle !important;
                                      text-align: center;
                                      border-right: 1px solid #ddd;
                                      border-bottom: 1px solid #ddd;
                                      width: 20%;
                                    "
                                  >
                                    <div
                                      v-frag
                                      v-if="planDeEstudioData.tipo == 0"
                                    >
                                      <v-btn
                                        @click="() => null"
                                        class="grey--text font-weight-regular"
                                        depressed
                                        text
                                        disabled
                                        color="grey"
                                        >Sin Mesa Aún</v-btn
                                      >
                                    </div>
                                    <div
                                      v-frag
                                      v-if="planDeEstudioData.tipo == 1"
                                    >
                                      <div
                                        v-frag
                                        v-if="
                                          planDeEstudioData.diasUltimaInscripcion >=
                                            550 &&
                                            planDeEstudioData.excepcion_validacion ==
                                              null
                                        "
                                      >
                                        <v-btn
                                          id="validateDays"
                                          style="
                                            border: 1px solid;
                                            padding-left: 24px;
                                            padding-right: 25px;
                                          "
                                          depressed
                                          text
                                          color="primary"
                                          @click="
                                            exepcionValidacion(
                                              planDeEstudioData.IDStB,
                                              examenMesa.id
                                            )
                                          "
                                        >
                                          Solicitar Excepcion
                                        </v-btn>
                                      </div>
  
                                      <div
                                        v-frag
                                        v-else-if="
                                          planDeEstudioData.diasUltimaInscripcion >=
                                            550 &&
                                            planDeEstudioData.excepcion_validacion
                                              .status == null
                                        "
                                      >
                                        <v-btn
                                          id="validateDays"
                                          style="
                                            border: 1px solid;
                                            padding-left: 24px;
                                            padding-right: 25px;
                                          "
                                          depressed
                                          text
                                          color="primary"
                                        >
                                          Esperando Confirmacion
                                        </v-btn>
                                      </div>
  
                                      <div
                                        v-frag
                                        v-else-if="
                                          planDeEstudioData.diasUltimaInscripcion >=
                                            550 &&
                                            planDeEstudioData.excepcion_validacion
                                              .status == 0
                                        "
                                      >
                                        <v-btn
                                          id="validateDays"
                                          style="
                                            border: 1px solid;
                                            padding-left: 24px;
                                            padding-right: 25px;
                                          "
                                          depressed
                                          text
                                          color="red"
                                        >
                                          Excepcion Rechazada
                                        </v-btn>
                                      </div>
  
                                      <div
                                        v-frag
                                        v-else-if="
                                          btnDeshabilitadoDeuda == true &&
                                            planDeEstudioData.diasUltimaInscripcion <
                                              550
                                        "
                                      >
                                        <v-btn
                                          id="ins_1"
                                          style="
                                            border: 1px solid;
                                            padding-left: 24px;
                                            padding-right: 25px;
                                          "
                                          :disabled="true"
                                          depressed
                                          text
                                          color="Colorsuccess"
                                        >
                                          Inscribir
                                        </v-btn>
                                      </div>
                                      <div v-else>
                                        <v-btn
                                          id="ins_2"
                                          v-show="
                                            extenderPeriodo == false &&
                                              examenMesa.cantidadInscipcion > 0
                                          "
                                          style="
                                            border: 1px solid;
                                            padding-left: 24px;
                                            padding-right: 25px;
                                          "
                                          @click="
                                            inscripcionMesaExamen(
                                              planDeEstudioData.IDStB,
                                              examenMesa.id,
                                              examenMesa.cantidadInscipcion
                                            )
                                          "
                                          depressed
                                          text
                                          color="Colorsuccess"
                                          >Inscribir</v-btn
                                        >
                                        <v-btn
                                          id="ins_0"
                                          v-show="
                                             examenMesa.cantidadInscipcion == 0
                                          "
                                          style="
                                            border: 1px solid;
                                            padding-left: 24px;
                                            padding-right: 25px;
                                          "
                                          disabled
                                          depressed
                                          text
                                          color="default"
                                          >Sin cupo</v-btn
                                        >
  
                                        <v-btn
                                          v-show="user.ext_mesas > 0"
                                          style="
                                            border: 1px solid;
                                            padding-left: 24px;
                                            padding-right: 25px;
                                          "
                                          @click="
                                            inscripcionMesaExamen(
                                              planDeEstudioData.IDStB,
                                              examenMesa.id
                                            )
                                          "
                                          depressed
                                          text
                                          color="Colorsuccess"
                                          >Inscribir</v-btn
                                        >
  
                                        <v-btn
                                          id="ins_3"
                                          v-show="planDeEstudioData.status == 0"
                                          style="
                                            border: 1px solid;
                                            padding-left: 24px;
                                            padding-right: 25px;
                                          "
                                          @click="
                                            inscripcionMesaExamen(
                                              planDeEstudioData.IDStB,
                                              examenMesa.id
                                            )
                                          "
                                          depressed
                                          text
                                          color="Colorsuccess"
                                          >Inscribir</v-btn
                                        >
                                      </div>
                                    </div>
                                    <div
                                      v-frag
                                      v-if="
                                        planDeEstudioData.tipo == 2 &&
                                          planDeEstudioData.status != 0
                                      "
                                    >
                                      <v-alert
                                        color="info"
                                        style="
                                          background-color: rgba(
                                            100,
                                            181,
                                            246,
                                            0.2
                                          ) !important;
                                          border: 1px solid;
                                          padding: 5px;
                                          margin-bottom: 5px !important;
                                          margin-top: 5px !important;
                                          padding-left: 0px;
                                          padding-right: 0px;
                                        "
                                      >
                                        Esperando confirmación
                                        <v-btn
                                          v-if="
                                            esFechaMenorOIgual(
                                              examenMesa.fechaTolerancia
                                            )
                                          "
                                          @click="
                                            cancelarInscripcionMesaExamen(
                                              planDeEstudioData
                                                .examen_inscipcion_alumno[0]
                                                .id_validacion
                                            )
                                          "
                                          small
                                          class="red--text text-decoration-underline font-weight-regular"
                                          depressed
                                          text
                                          color="red"
                                          >Cancelar</v-btn
                                        >
                                      </v-alert>
                                    </div>
                                    <div
                                      v-frag
                                      v-if="planDeEstudioData.tipo == 3"
                                    >
                                      <div v-if="planDeEstudioData != null">
                                        <div
                                          v-if="
                                            planDeEstudioData.examen_asociado !=
                                              null &&
                                              planDeEstudioData.examen_asociado
                                                .tipo_link == 0
                                          "
                                        >
                                          <v-btn
                                            @click="
                                              linkPrueba(
                                                planDeEstudioData.examen_asociado
                                                  .id_testpyr
                                              )
                                            "
                                            depressed
                                            style="
                                              border: 1px solid;
                                              padding-left: 33px;
                                              padding-right: 33px;
                                            "
                                            text
                                            color="rgb(143, 198, 220)"
                                          >
                                            Prueba
                                          </v-btn>
                                        </div>
  
                                        <div
                                          v-else-if="
                                            planDeEstudioData.examen_asociado !=
                                              null
                                          "
                                        >
                                          <v-btn
                                            :href="
                                              planDeEstudioData.examen_asociado
                                                .google_meet_url
                                            "
                                            depressed
                                            target="_blank"
                                            style="
                                              border: 1px solid;
                                              margin-left: 10px;
                                            "
                                            text
                                            color="rgb(219, 29, 74)"
                                          >
                                            ClassRoom
                                          </v-btn>
                                        </div>
  
                                        <div v-else>
                                          <v-alert
                                            color="Colorsuccess"
                                            dense
                                            style="
                                              color: white;
                                              padding: 5px 0px;
                                              margin-bottom: 5px !important;
                                              margin-top: 5px !important;
                                              display: inline-block;
                                              padding-left: 24px;
                                              padding-right: 25px;
                                            "
                                          >
                                            Inscripto
                                          </v-alert>
                                        </div>
                                      </div>
  
                                      <div v-else>
                                        <v-btn
                                          @click="() => null"
                                          class="grey--text font-weight-regular"
                                          depressed
                                          text
                                          disabled
                                          color="grey"
                                        >
                                          Sin Mesa Aún
                                        </v-btn>
                                      </div>
                                    </div>
                                    <div
                                      v-if="
                                        btnDeshabilitadoDeuda == false &&
                                          planDeEstudioData.validacion_pago ==
                                            'rechazada' &&
                                          (planDeEstudioData.validacion_academica ==
                                            'aceptada' ||
                                            planDeEstudioData.validacion_academica ===
                                              null) &&
                                          planDeEstudioData.tipo != 4
                                      "
                                    >
                                      <v-btn
                                        id="ins_4"
                                        style="
                                          border: 1px solid;
                                          padding-left: 24px;
                                          padding-right: 25px;
                                        "
                                        @click="
                                          inscripcionMesaExamen(
                                            planDeEstudioData.IDStB,
                                            examenMesa.id
                                          )
                                        "
                                        depressed
                                        text
                                        color="Colorsuccess"
                                        >Inscribir</v-btn
                                      >
                                    </div>
                                    <div
                                      class=""
                                      v-if="
                                        planDeEstudioData.status == 0 &&
                                          planDeEstudioData.tipo == null
                                      "
                                    >
                                      <v-btn
                                        style="border: 1px solid; padding-left: 24px; padding-right: 25px;"
                                        @click="
                                          inscripcionMesaExamen(
                                            planDeEstudioData.IDStB,
                                            examenMesa.id
                                          )
                                        "
                                        depressed
                                        text
                                        color="Colorsuccess"
                                        >Inscribir</v-btn
                                      >
                                    </div>
                                    <div
                                      v-frag
                                      v-else-if="planDeEstudioData.tipo == 4"
                                    >
                                      <v-alert
                                        color="error"
                                        style="
                                          color: white;
                                          padding: 5px 0px;
                                          margin-bottom: 5px !important;
                                          margin-top: 5px !important;
                                          display: inline-block;
                                          padding-left: 24px;
                                          padding-right: 25px;
                                        "
                                      >
                                        Rechazado
                                      </v-alert>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </template>
                          </v-simple-table>
                        </div>
                        <br /><br />
                      </div>
                      <!-- mesa de exames -->
  
                      <!-- pagos -->
                      <div v-frag v-if="item.id == 3">
                        <div
                          v-frag
                          v-for="(itemTable, keyTable) in item.data"
                          :key="keyTable"
                        >
                          <div
                            class="text-xs-h4 text-sm-h4 text-md-h4 text-lg-h4 text-xl-h4 primary--text"
                          >
                            {{ itemTable.nombre }}
                          </div>
                          <v-simple-table>
                            <template v-slot:default>
                              <thead>
                                <tr>
                                  <th class="text-left">Concepto</th>
                                  <th class="text-left">Monto</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-for="(itemTableData,
                                  keyItemTableData) in itemTable.data"
                                  :key="keyItemTableData"
                                >
                                  <td>{{ itemTableData.Concepto }}</td>
                                  <td>${{ itemTableData.Monto }}</td>
                                </tr>
                              </tbody>
                            </template>
                          </v-simple-table>
                        </div>
                        <br /><br />
                      </div>
                      <!-- pagos -->
  
                      <!-- test -->
  
                      <div v-frag v-if="item.id == 4">
                        <div>
                          <v-simple-table>
                            <template v-slot:default>
                              <thead>
                                <tr>
                                  <th class="text-center">Nombre del Test</th>
                                  <th class="text-center">Test (BETA)</th>
                                  <th class="text-center">Formulario Google</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-for="(test, keyTable) in item.data"
                                  :key="keyTable"
                                >
                                  <td>
                                    {{
                                      $vuetify.breakpoint.name == "xs"
                                        ? test.titulo
                                        : test.titulo
                                    }}
                                  </td>
  
                                  <td v-if="test.tipo == 'Practica'">
                                    <div v-frag>
                                      <v-btn
                                        @click="linkTest(test)"
                                        small
                                        class="info--text text-decoration-underline font-weight-regular"
                                        depressed
                                        text
                                        color="info"
                                        >Presentar Test</v-btn
                                      >
                                    </div>
                                  </td>
                                  <td v-else-if="test.tipo == 'Examen Final'">
                                    <div
                                      v-if="
                                        test.tipo_examen == 'Recuperatorio' &&
                                          test.presentarExamenRecuperatorio
                                      "
                                    >
                                      <div
                                        v-frag
                                        v-if="
                                          test.testPresentado == false &&
                                            puedeRendirExamen(test) == true
                                        "
                                      >
                                        <v-btn
                                          @click="linkTest(test)"
                                          small
                                          class="info--text text-decoration-underline font-weight-regular"
                                          depressed
                                          text
                                          color="info"
                                          >Presentar Test</v-btn
                                        >
                                      </div>
  
                                      <div
                                        v-else-if="
                                          puedeRendirExamen(test) == false
                                        "
                                      >
                                        <v-btn small color="danger"
                                          >Test Cerrado</v-btn
                                        >
                                      </div>
  
                                      <div v-frag v-else>
                                        <v-btn small color="success"
                                          >Test Presentado</v-btn
                                        >
                                      </div>
                                    </div>
  
                                    <div
                                      v-else-if="
                                        test.tipo_examen === 'Examen Final' &&
                                          test.presentarExamenFinal === true
                                      "
                                    >
                                      <div
                                        v-frag
                                        v-if="
                                          test.testPresentado == false &&
                                            puedeRendirExamen(test) == true
                                        "
                                      >
                                        <v-btn
                                          @click="linkTest(test)"
                                          small
                                          class="info--text text-decoration-underline font-weight-regular"
                                          depressed
                                          text
                                          color="info"
                                          >Presentar Test</v-btn
                                        >
                                      </div>
  
                                      <div
                                        v-else-if="
                                          puedeRendirExamen(test) == false
                                        "
                                      >
                                        <v-btn small color="danger"
                                          >Test Cerrado</v-btn
                                        >
                                      </div>
  
                                      <div v-frag v-else>
                                        <v-btn small color="success"
                                          >Test Presentado</v-btn
                                        >
                                      </div>
                                    </div>
  
                                    <div
                                      v-else-if="
                                        test.tipo_examen == '2do Parcial' ||
                                          test.tipo_examen == '1er Parcial'
                                      "
                                    >
                                      <div
                                        v-frag
                                        v-if="
                                          test.testPresentado == false &&
                                            puedeRendirExamen(test) == true
                                        "
                                      >
                                        <v-btn
                                          @click="linkTest(test)"
                                          small
                                          class="info--text text-decoration-underline font-weight-regular"
                                          depressed
                                          text
                                          color="info"
                                          >Presentar Test</v-btn
                                        >
                                      </div>
  
                                      <div
                                        v-else-if="
                                          puedeRendirExamen(test) == false
                                        "
                                      >
                                        <v-btn small color="danger"
                                          >Test Cerrado</v-btn
                                        >
                                      </div>
  
                                      <div v-frag v-else>
                                        <v-btn small color="success"
                                          >Test Presentado</v-btn
                                        >
                                      </div>
                                    </div>
                                  </td>
  
                                  <td>
                                    <v-btn
                                      :href="test.url_meet"
                                      small
                                      class="info--text text-decoration-underline font-weight-regular"
                                      depressed
                                      text
                                      color="info"
                                      >Ver Aquí</v-btn
                                    >
                                  </td>
                                </tr>
                              </tbody>
                            </template>
                          </v-simple-table>
                        </div>
                      </div>
  
                      <!-- test -->
  
                      <!-- test -->
  
                      <div v-frag v-if="item.id == 6">
                        <div>
                          <v-simple-table>
                            <template v-slot:default>
                              <thead>
                                <tr>
                                  <th class="text-center">Materia</th>
                                  <th class="text-center">Nombre del Test</th>
                                  <th class="text-center">Tipo</th>
                                  <th class="text-center">Fecha</th>
                                  <th class="text-center">Hora</th>
                                  <th class="text-center">Test (BETA)</th>
                                  <th class="text-center">EN DESARROLLO</th>
                                  <th class="text-center">Nota</th>
                                  <th class="text-center">Link Test</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-for="(test, keyTable) in item.data"
                                  :key="keyTable"
                                >
                                  <td>
                                    {{
                                      $vuetify.breakpoint.name == "xs"
                                        ? test.nombreMateria
                                        : test.nombreMateria
                                    }}
                                  </td>
                                  <td>
                                    {{
                                      $vuetify.breakpoint.name == "xs"
                                        ? test.titulo
                                        : test.titulo
                                    }}
                                  </td>
                                  <td>
                                    <div v-if="test.tipo_examen != null">
                                      {{ test.tipo_examen }}
                                    </div>
  
                                    <div v-else>Practica</div>
                                  </td>
                                  <td>
                                    <div v-if="test.tipo != 'Practica'">
                                      <span class="font-weight-black red--text">
                                        Periodo Valido <br />
                                        {{ test.fecha_test_desde }} /
                                        {{ test.fecha_test_hasta }}
                                      </span>
                                    </div>
                                  </td>
                                  <td>
                                    <div v-if="test.tipo != 'Practica'">
                                      <span class="font-weight-black red--text">
                                        Horario Valido <br />
                                        {{ test.hora_inicio }} a
                                        {{ test.hora_final }}
                                      </span>
                                    </div>
                                  </td>
                                  <td v-if="test.tipo == 'Practica'">
                                    <div v-frag>
                                      <v-btn
                                        @click="linkTest(test)"
                                        small
                                        class="info--text text-decoration-underline font-weight-regular"
                                        depressed
                                        text
                                        color="info"
                                        >Presentar Test</v-btn
                                      >
                                    </div>
                                  </td>
                                  <td v-else-if="test.tipo == 'Examen Final'">
                                    <div
                                      v-if="
                                        test.tipo_examen == 'Recuperatorio' &&
                                          test.presentarExamenRecuperatorio
                                      "
                                    >
                                      <div
                                        v-frag
                                        v-if="
                                          test.testPresentado == false &&
                                            puedeRendirExamen(test) == true
                                        "
                                      >
                                        <v-btn
                                          @click="linkTest(test)"
                                          small
                                          class="info--text text-decoration-underline font-weight-regular"
                                          depressed
                                          text
                                          color="info"
                                          >Presentar Test</v-btn
                                        >
                                      </div>
  
                                      <div
                                        v-else-if="
                                          puedeRendirExamen(test) == false
                                        "
                                      >
                                        <v-btn small color="danger"
                                          >Test Cerrado</v-btn
                                        >
                                      </div>
  
                                      <div v-frag v-else>
                                        <v-btn small color="success"
                                          >Test Presentado</v-btn
                                        >
                                      </div>
                                    </div>
  
                                    <div
                                      v-else-if="
                                        test.tipo_examen === 'Examen Final' &&
                                          test.presentarExamenFinal === true
                                      "
                                    >
                                      <div
                                        v-frag
                                        v-if="
                                          test.testPresentado == false &&
                                            puedeRendirExamen(test) == true
                                        "
                                      >
                                        <v-btn
                                          @click="linkTest(test)"
                                          small
                                          class="info--text text-decoration-underline font-weight-regular"
                                          depressed
                                          text
                                          color="info"
                                          >Presentar Test</v-btn
                                        >
                                      </div>
  
                                      <div
                                        v-else-if="
                                          puedeRendirExamen(test) == false
                                        "
                                      >
                                        <v-btn small color="danger"
                                          >Test Cerrado</v-btn
                                        >
                                      </div>
  
                                      <div v-frag v-else>
                                        <v-btn small color="success"
                                          >Test Presentado</v-btn
                                        >
                                      </div>
                                    </div>
  
                                    <div
                                      v-else-if="
                                        test.tipo_examen == '2do Parcial' ||
                                          test.tipo_examen == '1er Parcial'
                                      "
                                    >
                                      <div
                                        v-frag
                                        v-if="
                                          test.testPresentado == false &&
                                            puedeRendirExamen(test) == true
                                        "
                                      >
                                        <v-btn
                                          @click="linkTest(test)"
                                          small
                                          class="info--text text-decoration-underline font-weight-regular"
                                          depressed
                                          text
                                          color="info"
                                          >Presentar Test</v-btn
                                        >
                                      </div>
  
                                      <div
                                        v-else-if="
                                          puedeRendirExamen(test) == false
                                        "
                                      >
                                        <v-btn small color="danger"
                                          >Test Cerrado</v-btn
                                        >
                                      </div>
  
                                      <div v-frag v-else>
                                        <v-btn small color="success"
                                          >Test Presentado</v-btn
                                        >
                                      </div>
                                    </div>
                                  </td>
  
                                  <td>
                                    <v-btn
                                      :href="test.url_meet"
                                      small
                                      class="info--text text-decoration-underline font-weight-regular"
                                      depressed
                                      text
                                      color="info"
                                      >Ver Aquí</v-btn
                                    >
                                  </td>
  
                                  <td>
                                    <div v-if="test.mostrar_nota">
                                      <div v-if="test.nota >= 4">
                                        <div class="my-2">
                                          <v-btn color="success" fab x-small dark>
                                            {{ test.nota }}
                                          </v-btn>
                                        </div>
                                      </div>
                                      <div v-else>
                                        <div class="my-2">
                                          <v-btn color="error" fab x-small dark>
                                            {{ test.nota }}
                                          </v-btn>
                                        </div>
                                      </div>
                                    </div>
                                  </td>
  
                                  <td>
                                    <div
                                      v-if="
                                        test.examen_url != null &&
                                          haPasadoMasDeUnDia(test.fecha_carga) ==
                                            false
                                      "
                                    >
                                      <div>
                                        <div class="my-2">
                                          <v-btn
                                            :href="test.examen_url"
                                            target="_blank"
                                            small
                                            class="info--text text-decoration-underline font-weight-regular"
                                            depressed
                                            text
                                            color="info"
                                            >Ver Aquí</v-btn
                                          >
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </template>
                          </v-simple-table>
                        </div>
                      </div>
  
                      <!-- test -->
  
                      <!-- Materias Faltantes -->
  
                      <div v-frag v-if="item.id == 5">
                        <v-simple-table>
                          <template v-slot:default>
                            <thead>
                              <tr>
                                <th class="text-left">Materia</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="itemTableData in materiaFaltantes"
                                :key="itemTableData.curso_id + '-' + itemTableData.id"
                              >
                                <td>{{ itemTableData.materia }}</td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
  
                        <br /><br />
                      </div>
  
                      <!-- Materias Faltantes -->
                    </v-col>
                  </v-row>
                </v-expand-transition>
              </v-col>
            </v-row>
            <!-- </v-container> -->
          </v-card>
        </div>
      </div>
      <div v-if="sendvalidation">
        <DialogValidationAlumno />
      </div>
      <v-dialog v-model="apareceModalMedallaIncial" width="auto">
        <v-card>
          <v-card-title class="headline" primary-title>
            ¡Felicidades!
          </v-card-title>
          <v-card-text
            class="mt-3 text-center d-flex flex-column justify-center align-center"
          >
            Has ganado el siguiente reconocimiento por haber ingresado por primera
            vez a nuestra plataforma
  
            <v-img
              class="mt-4"
              :aspect-ratio="16 / 9"
              width="150"
              contain
              :src="require('../assets/inicial.png')"
            ></v-img>
          </v-card-text>
          <v-card-actions>
            <v-btn
              color="primary"
              block
              @click="apareceModalMedallaIncial = false"
              >Cerrar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </template>
  
  <script>
  import CardIeaAppMain from "../components/CardIeaAppMain";
  import CardIeaCategory from "../components/CardIeaCategory";
  import DialogValidationAlumno from "../components/DialogValidationAlumno";
  import ModalSubsripcionExterna from "../components/ModalSubsripcionExterna";
  import moment from "moment";
  moment.locale("es");
  
  // Configurar la zona horaria para todas las instancias de moment
  moment.fn.toJSON = function() {
    return this.format();
  };
  moment.parseZone = function(input) {
    return moment(input).utcOffset(-180); // Argentina UTC-3
  };
  
  export default {
    name: "Home",
    components: {
      CardIeaAppMain,
      CardIeaCategory,
      DialogValidationAlumno,
      ModalSubsripcionExterna
    },
    created() {
      if (this.user && this.user.tipoUsuario) {
        this.fetchMenu();
      }
    },
    data: function() {
      let initialMenu = [];
      let initialDocs = [];
      let initialDocsPend = 0;
      let initialWaiting = true;
      let initialTitulo = "";
      let initialDesc = "";

      try {
        const cachedMenu = sessionStorage.getItem("iea_menu");
        if (cachedMenu) {
          initialMenu = JSON.parse(cachedMenu);
        }
        const cachedNovedades = sessionStorage.getItem("iea_novedades");
        if (cachedNovedades) {
          const nov = JSON.parse(cachedNovedades);
          initialTitulo = nov.titulo || "";
          initialDesc = nov.descripcion || "";
        }
        const cachedDocs = sessionStorage.getItem("iea_docs");
        if (cachedDocs) {
          initialDocs = JSON.parse(cachedDocs);
          let pend = 0;
          for (const d of initialDocs) {
            if (d && d.validar == 0) pend++;
          }
          initialDocsPend = pend;
          initialWaiting = false;
        }
      } catch (e) {
        console.error(e);
      }

      return {
        inscripcionesDisponibles: [],
        extenderPeriodo: false,
        today: moment().format("YYYY-MM-DD"),
        alumnoCursoIntroductorio: null,
        tituloNovedades: initialTitulo,
        descripcionNovedades: initialDesc,
        sendvalidation: false,
        documentosAlumno: initialDocs,
        waiting: initialWaiting,
        docsPend: initialDocsPend,
        loadingMenu: initialMenu.length === 0,
        materiaFaltantes: [],
        dialog_pago_atrasado: false,
        btnDeshabilitadoDeuda: false,
        menu: initialMenu,
  
      existeContactoBce: false,
      contactoBce: null,
      llenarFormulario: false,
      ocultarPanels:true,
      panels: [
        {
          id: 0,
          text: "Tus Inscripciones a Materias",
          active: false,
          data: [],
          tipoUsuario: ["alumno"],
          show: true
        },
        {
          id: 1,
          text: "Tus Inscripciones a Exámenes",
          active: false,
          data: [],
          tipoUsuario: ["alumno"],
          show: true
        },
        /*
        {
          id: 2,
          text: "Plan de estudio y classroom",
          active: false,
          data: [],
          tipoUsuario: "alumno",
        },
        */
        /*{
          id: 3,
          text: "Tus Pagos",
          active: false,
          data: [],
          tipoUsuario: ["alumno"],
          show: true,
        },
        */
        /* {
          id: 4,
          text: "Practicas",
          active: false,
          data: [],
          tipoUsuario: ["alumno"],
          show: true
        }, */
        {
          id: 5,
          text: "Materias Que Me Faltan",
          active: false,
          data: [],
          tipoUsuario: ["alumno"],
          show: true
        },
        {
          id: 6,
          text: "Parciales y Examenes Finales",
          active: false,
          data: [],
          tipoUsuario: "alumno",
          show: true
        }
      ],
      showButtonClock: false,
      switchLegacyVersion: false,
      apareceModalMedallaIncial: false
    };
  },
    computed: {
      isWithinAllowedTimeFrame() {
        if (!this.user.fechaIncripcion) return false;
        const fechaInscripcion = new Date(this.user.fechaIncripcion);
        const fechaLimite = new Date(fechaInscripcion);
        fechaLimite.setMonth(fechaLimite.getMonth() + 1); // Añadir un mes a la fecha de inscripción
        const fechaActual = new Date();
  
        return fechaActual <= fechaLimite;
      },
      diferenciaDias() {
        if (!this.user.fechaIncripcion) return false;
        const fechaInscripcion = new Date(this.user.fechaIncripcion);
        const fechaLimite = new Date(fechaInscripcion);
        fechaLimite.setMonth(fechaLimite.getMonth() + 1); // Añadir un mes a la fecha de inscripción
        const fechaActual = new Date();
  
        const diferenciaMilisegundos = fechaLimite - fechaActual;
  
        // Convertir la diferencia de milisegundos a días
        return Math.ceil(diferenciaMilisegundos / (1000 * 60 * 60 * 24));
      },
      tieneBadge1() {
        return this.$store.getters.tieneBadge1;
      },
      tieneBadge2() {
        return this.$store.getters.tieneBadge2;
      },
      tieneBadge3() {
        return this.$store.getters.tieneBadge3;
      },
      porcentaje1() {
        return this.$store.getters.porcentaje1;
      },
      porcentaje2() {
        return this.$store.getters.porcentaje2;
      },
      porcentaje3() {
        return this.$store.getters.porcentaje3;
      },
      user() {
        return this.$store.getters.user;
      },
      menuValidar: function() {
        let usuario = this.$store.getters.user;
        if (usuario.tipoUsuario == "alumno") {
          if (usuario.validacion_inscripcion != 0) {
            return this.menu.filter(function(m) {
              return m.tipoUsuario.includes(usuario.tipoUsuario);
            });
          } else {
            return [];
          }
        } else {
          return this.menu.filter(function(m) {
            return m.tipoUsuario.includes(usuario.tipoUsuario);
          });
        }
      },
      apareceModalInicial() {
        return this.$store.getters.apareceModalInicial;
      },
      primeroIngreso() {
        return this.$store.getters.primeroIngreso;
      }
    },
    watch: {
      user: {
        handler(val) {
          if (val && val.tipoUsuario == "profesor" && this.$route.query.legacy !== "true") {
            this.$router.push({ name: "HomeProfesor" });
          }
        },
        immediate: true
      }
    },
    mounted() {
      if (this.user && this.user.tipoUsuario == "profesor" && this.$route.query.legacy !== "true") {
        this.$router.push({ name: "HomeProfesor" });
        return;
      }
      if (this.user && this.user.tipoUsuario == "alumno") {
        this.isActiveTramites();
        this.novedadesList();
        this.registerAccess();
        this.documentosRequeridos(this.user.IDStB);
        this.obtenerContacto();
        this.obtenerFormulario();
  
        if (this.primeroIngreso && !this.apareceModalInicial) {
          this.apareceModalMedallaIncial = true;
          this.$store.commit("apareceModalInicial", true);
        }
      }
      if (
        this.user && (
        this.user.IDStB == 11103 ||
        this.user.IDStB == 5680 ||
        this.user.kanban )
      ) {
        this.showButtonClock = true;
      }
  
      if (!this.getCookie("mensajeImpago")) {
        this.showMensajeImpago();
      }
      if (!this.menu || this.menu.length === 0) {
        this.fetchMenu();
      }
    },
    methods: {
      fetchMenu() {
        if (!this.user || !this.user.tipoUsuario) return;
        this.loadingMenu = this.menu.length === 0;
        this.$API
          .get(
            {
              url: "menu/W/" + this.user.tipoUsuario,
              data: {}
            },
            false
          )
          .then(res => {
            if (res && res.menus) {
              this.menu = res.menus;
              try {
                sessionStorage.setItem("iea_menu", JSON.stringify(res.menus));
              } catch (e) {
        console.error(e);
      }
            }
          })
          .catch(err => {
            console.error("Error al cargar menu:", err);
          })
          .finally(() => {
            this.loadingMenu = false;
          });
      },

      esFechaMenorOIgual(fecha) {
        const fechaTolerancia = new Date(fecha);
        const fechaActual = new Date();
        return fechaTolerancia >= fechaActual;
      },
      async pagarMontoDeuda(id_mesa) {
        console.log(id_mesa);
        let dataSend = {
          // id_inscripcion:id_inscripcion,
          id_mesa: id_mesa,
          alumno: this.user.IDStB
          // id_validacion:id_validacion
        };
  
        let url = "mobbex/mobbex-pago-deuda-examen";
        this.$API
          .post({
            url: url,
            data: dataSend
          })
          .then(res => {
            location.href = res.data.url;
          });
      },
      haPasadoMasDeUnDia(fechaCarga) {
        const fechaCargaDate = new Date(fechaCarga);
        const fechaCargaMasUnDia = new Date(
          fechaCargaDate.getTime() + 24 * 60 * 60 * 1000
        ); // Añadir un día
        const now = new Date();
        const unDia = 24 * 60 * 60 * 1000; // Milisegundos en un día
  
        return now - fechaCargaMasUnDia > unDia;
      },
      puedeRendirExamen(examen) {
        const fechaDesde = moment(
          examen.fecha_test_desde + " " + examen.hora_inicio
        ).utcOffset(-180);
        const fechaHasta = moment(
          examen.fecha_test_hasta + " " + examen.hora_final
        ).utcOffset(-180);
        const now = moment().utcOffset(-180);
  
        return now.isBetween(fechaDesde, fechaHasta, null, "[]");
      },
      async openPanel(item) {
        if (item.id == 2) {
          if (!item.active) {
            await this.planDeEstudioGet();
          } else {
            // this.panels[2].data = []
          }
        }
        if (item.id == 1) {
          if (!item.active) {
            await this.mesaDeExamen();
          } else {
            // this.panels[1].data = []
          }
        }
        if (item.id == 0) {
          if (!item.active) {
            await this.mesaDeMateria();
          } else {
            // this.panels[1].data = []
          }
        }
  
        if (item.id == 3) {
          if (!item.active) {
            await this.tuPagos();
          } else {
            // this.panels[1].data = []
          }
        }
  
        if (item.id == 4) {
          if (!item.active) {
            await this.testPrueba();
          } else {
            // this.panels[1].data = []
          }
        }
  
        if (item.id == 5) {
          if (!item.active) {
            await this.MateriasFaltan();
          } else {
            // this.panels[1].data = []
          }
        }
        if (item.id == 6) {
          if (!item.active) {
            await this.examenes();
          } else {
            // this.panels[1].data = []
          }
        }
  
        item.active = !item.active;
      },
  
      getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) {
          const cookieValue = parts
            .pop()
            .split(";")
            .shift();
          return cookieValue;
        }
        return null;
      },
  
      async showMensajeImpago() {
        let app = this;
  
        await this.$API
          .get(
            {
              url: "alumno/status-activo/" + this.user.IDStB,
              data: {}
            },
            false
          )
          .then(res => {
            const tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);
            document.cookie = `mensajeImpago=${JSON.stringify(
              res
            )}; expires=${tomorrow.toUTCString()}; path=/`;
            app.dialog_pago_atrasado = res.is_active;
          });
      },
  
      async novedadesList() {
        await this.$API
          .get(
            {
              url: "notificaciones/index",
              data: {}
            },
            false
          )
          .then(res => {
            if (res && res.length > 0) {
              this.tituloNovedades = res[res.length - 1].titulo.toUpperCase();
              this.descripcionNovedades = res[res.length - 1].descripcion;
              try {
                sessionStorage.setItem(
                  "iea_novedades",
                  JSON.stringify({
                    titulo: this.tituloNovedades,
                    descripcion: this.descripcionNovedades
                  })
                );
              } catch (e) {
        console.error(e);
      }
            }
          })
          .catch(err => {
            console.error("Error novedades:", err);
          });
      },
      async registerAccess() {
        await this.$API
          .post(
            {
              url: "alumno/register-access",
              data: {
                tipo: "web"
              }
            },
            false
          )
          .then(res => {
            console.log(res);
          });
      },
  
      documentosPendientes() {
        let app = this;
        if (typeof app.documentosAlumno !== "undefined") {
          app.docsPend = 0;
          for (const item in app.documentosAlumno) {
            if (app.documentosAlumno[item].validar == 0) app.docsPend++;
          }
        }
      },
  
      async documentosRequeridos(alumno) {
        await this.$API
          .get(
            {
              url: "documentos/requeridos/" + alumno,
              data: {}
            },
            false
          )
          .then(res => {
            this.documentosAlumno = res || [];
            this.documentosPendientes();
            try {
              sessionStorage.setItem("iea_docs", JSON.stringify(res || []));
            } catch (e) {
        console.error(e);
      }
          })
          .catch(err => {
            console.error("Error documentos requeridos:", err);
          })
          .finally(() => {
            this.waiting = false;
          });
      },
      async logout() {
        let that = this;
        await this.$API
          .get({
            url: "alumno/logout?web=true",
            data: {}
          })
          .then(() => {
            setTimeout(() => {
              that.$store.dispatch("token", "");
              that.$store.dispatch("user", {});
              that.$store.dispatch("tieneBadge1", false);
              that.$store.dispatch("tieneBadge2", false);
              that.$store.dispatch("tieneBadge3", false);
              that.$store.dispatch("porcentaje1", 0);
              that.$store.dispatch("porcentaje2", 0);
              that.$store.dispatch("porcentaje3", 0);
              that.$store.dispatch("primeroIngreso", false);
              that.$store.dispatch("apareceModalInicial", false);
              that.$store.dispatch("carreraPrincipal", "");
              that.$store.dispatch("imagenbs", "");
  
              that.$router.replace({ name: "Login" });
            }, 1000);
          });
      },
      menuAction(route, validate) {
        if (
          route &&
          (validate == false ||
            (validate == true &&
              this.user.borrado !== "1" && !this.user.excedente &&
              this.user.alumno_mora !== true))
        ) {
          if (route == "Logout") {
            this.logout();
          } else if (route == "Verifier") {
            this.$store.dispatch("omitirValidacion", false);
            this.sendvalidation = true;
          } else {
            console.log(route);
            let finalRoute = route;
            if (route == "Publicacion") finalRoute = "Publicaciones";
            this.$router.push({
              name: finalRoute
            });
          }
        }
      },
      handleSwitchNewVersion() {
        if (this.switchLegacyVersion) {
          this.goToNewVersion();
        }
      },
      goToNewVersion() {
        this.$router.push({ name: "HomeProfesor" });
      },
      async testPrueba() {
        await this.$API
          .get({
            url: "pyr-test/select",
            data: {}
          })
          .then(res => {
            this.panels.find(element => element.id == 4).data = res;
  
            console.log("panel 4", this.panels[4].data);
          });
      },
      async examenes() {
        await this.$API
          .get({
            url: "examenes",
            data: {}
          })
          .then(res => {
            this.panels.find(element => element.id == 6).data = res;
  
            console.log("panel 6", this.panels[6]);
          });
      },
      async planDeEstudioGet() {
        await this.$API
          .get({
            url: "plan-de-estudio/index",
            data: {}
          })
          .then(res => {
            this.panels[2].data = res;
          });
      },
      async mesaDeExamen() {
        await this.$API
          .get({
            url: "examen/mesas",
            data: {}
          })
          .then(res => {
            for (let index = 1; index <= res.cantidad; index++) {
              this.inscripcionesDisponibles.push(index);
            }
            this.panels[1].data = res;
  
            this.btnDeshabilitadoDeuda = res.data.some(curso => {
              const materias = Object.values(curso.curso.plan_de_estudio_v2);
              return materias.some(materia => materia.rechazo_pago === 1);
            });
          });
      },
      async mesaDeMateria() {
        await this.$API
          .get({
            url: "materia/mesas",
            data: {}
          })
          .then(res => {
            this.panels[0].data = res;
          });
      },
      async tuPagos() {
        await this.$API
          .get({
            url: "alumno/pagos",
            data: {}
          })
          .then(res => {
            this.panels[3].data = res;
          });
      },
  
      async inscripcionMesaExamen(examen, mesa, cantidadInscripcion) {
        await this.$API
          .post({
            url: "examen/mesas-inscripcion-new",
            data: {
              materia_id: examen,
              examenMesa_id: mesa,
              cantidadInscripcion: cantidadInscripcion
            }
          })
          .then(() => {
            this.mesaDeExamen();
          });
      },
      async cancelarInscripcionMesaExamen(id) {
        await this.$API
          .post({
            url: "examen/cancelar-inscripcion",
            data: {
              id: id
            }
          })
          .then(() => {
            this.mesaDeExamen();
          });
      },
  
      async inscripcionMesaMateria(examen, mesa) {
        await this.$API
          .post({
            url: "materia/mesas-inscripcion",
            data: {
              materia_id: examen,
              examenMesa_id: mesa
            }
          })
          .then(() => {
            this.mesaDeMateria();
          });
      },
      async cancelarInscripcionMesaMateria(id) {
        await this.$API
          .post({
            url: "materia/cancelar-inscripcion",
            data: {
              id: id
            }
          })
          .then(() => {
            this.mesaDeMateria();
          });
      },
      async isActiveTramites() {
        await this.$API
          .get(
            {
              url: "get-config/ENABLE_TRAMITES",
              data: {}
            },
            false
          )
          .then(res => {
            if (res == "1" && this.menu) {
              const tramites = this.menu.find(m => m.text === "Trámites" || m.route === "tramites");
              if (tramites) tramites.show = true;
              else if (this.menu[22]) this.menu[22].show = true;
            }
          })
          .catch(e => {
            console.error(e);
          });
      },
      // #404: mismo arreglo que views/Panel/Faltan.vue (ver ahí).
      async MateriasFaltan() {
        await this.$API
          .get({ url: "plan-estudio-alumno", data: {} })
          .then(res => {
            const cursos = Array.isArray(res) ? res : [];
            this.materiaFaltantes = cursos.flatMap(c =>
              c.materias
                .filter(m => m.estado !== "aprobada")
                .map(m => ({ ...m, curso_id: c.curso_id }))
            );
          });
      },
      linkVideo(link) {
        this.$router.push({
          name: "MateriaCodigoClaseVideoAuth",
          params: {
            catedra: link.catedra_uuid,
            planestudio: link.planEstudio
          }
        });
      },
  
      linkTest(test) {
        this.$router.push({
          name: "examen",
          params: {
            test: test.test_id,
            examen: test.id
          }
        });
      },
  
      linkPrueba(idPrueba) {
        this.$router.push({
          name: "examen",
          params: {
            test: idPrueba
          }
        });
      },
      async exepcionValidacion(materia, mesa) {
        await this.$API
          .post({
            url: "exepcion-validacion-inscripcion",
            data: {
              materia_id: materia,
              mesa_id: mesa
            }
          })
          .then((res) => {
            console.log(res)
            this.mesaDeExamen();
          });
      },
      async obtenerContacto() {
        await this.$API
          .post(
            {
              url: "contacto-bce/obtener-contacto-vista",
              data: {
                alumno: this.user.IDStB
              }
            },
            false
          )
          .then(res => {
            console.log("respuesta de alert ", res);
            this.existeContactoBce = res.existe;
            this.contactoBce = res.contacto;
          });
      },
      async obtenerFormulario() {
        await this.$API
          .post(
            {
              url: "contacto-bce/obtener-formulario",
              data: {
                alumno: this.user.IDStB
              }
            },
            false
          )
          .then(res => {
            this.llenarFormulario = res.existe;
          });
      }
    }
  };
  </script>
  
  <style>
  .boton-pago {
    display: inline-block;
    padding: 5px 10px;
    background-color: #0056b3;
    color: #fff !important;
    text-decoration: none;
    border: none;
    border-radius: 5px;
    cursor: pointer;
  }
  
  .boton-pago:hover {
    background-color: #0044a3;
  }
  
  .td-mesa {
    vertical-align: middle !important;
    border-right: 1px solid #ddd;
  }
  
@keyframes skeletonPulse {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

.menu-card-skeleton {
  background: rgba(255, 255, 255, 0.65) !important;
  border: 1px solid rgba(255, 255, 255, 0.5) !important;
  pointer-events: none;
}

.skeleton-icon-box {
  width: 64px;
  height: 64px;
  border-radius: 16px;
  background: linear-gradient(90deg, #e2e8f0 25%, #f8fafc 50%, #e2e8f0 75%);
  background-size: 200% 100%;
  animation: skeletonPulse 1.6s infinite ease-in-out;
}

.skeleton-text-pill {
  width: 70%;
  height: 12px;
  background: linear-gradient(90deg, #e2e8f0 25%, #f8fafc 50%, #e2e8f0 75%);
  background-size: 200% 100%;
  animation: skeletonPulse 1.6s infinite ease-in-out;
}

.skeleton-avatar-sm {
  width: 40px;
  height: 40px;
  background: linear-gradient(90deg, #e2e8f0 25%, #f8fafc 50%, #e2e8f0 75%);
  background-size: 200% 100%;
  animation: skeletonPulse 1.6s infinite ease-in-out;
}

.skeleton-line-title {
  width: 35%;
  height: 14px;
  background: linear-gradient(90deg, #e2e8f0 25%, #f8fafc 50%, #e2e8f0 75%);
  background-size: 200% 100%;
  animation: skeletonPulse 1.6s infinite ease-in-out;
}

.skeleton-line-sub {
  width: 60%;
  height: 11px;
  background: linear-gradient(90deg, #e2e8f0 25%, #f8fafc 50%, #e2e8f0 75%);
  background-size: 200% 100%;
  animation: skeletonPulse 1.6s infinite ease-in-out;
}

@keyframes cardStaggerIn {
  from {
    opacity: 0;
    transform: translateY(10px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.menu-stagger-item {
  animation: cardStaggerIn 0.28s cubic-bezier(0.16, 1, 0.3, 1) both;
}

</style>